"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var CreateRole_vue_1 = __importDefault(require("../TheRoles/CreateRole.vue"));
var DeleteRole_vue_1 = __importDefault(require("./DeleteRole.vue"));
var RoleSelect_vue_1 = __importDefault(require("./RoleSelect.vue"));
var roles_json_1 = __importDefault(require("../../../roles.json"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
exports.default = vue_1.default.extend({
    name: "top-menu",
    components: {
        CreateRole: CreateRole_vue_1.default,
        DeleteRole: DeleteRole_vue_1.default,
        RoleSelect: RoleSelect_vue_1.default
    },
    props: {
        roles: {
            type: Array
        },
        currentRole: {
            type: Object
        }
    },
    data: function () {
        return {
            allRoles: roles_json_1.default,
            allPermissions: permissions_json_1.default
        };
    }
});
